import { type RefObject, useLayoutEffect, useState } from "react";

// Custom hook to get the element from ref on initial render.
// This helps us avoid accessing a ref value during render, can lead
// to unexpected behavior or issues, particularly with features like
// Concurrent Rendering in React 18.
export function useElementFromRef<T extends HTMLElement>(ref: RefObject<T | null> | undefined): T | null {
  const [element, setElement] = useState<T | null>(null);

  // NOTE: We need to use useLayoutEffect here to ensure that the container is
  // set before the browser paints, which is important for positioning the
  // element correctly relative to the ref. This also helps us avoid
  // issues with cascading renders.
  useLayoutEffect(() => {
    if (ref?.current) {
      setElement(ref?.current ?? null);
    }
  }, [ref?.current]);

  return element;
}
